import { AfterViewInit, Component, DestroyRef, inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogClose } from '@angular/material/dialog';
import { StoryImage } from '../../../model/story/story-image.model';
import { MatIcon } from '@angular/material/icon';
import { MatStep, MatStepper, MatStepperNext, MatStepperPrevious } from '@angular/material/stepper';
import { MatButton } from '@angular/material/button';
import { filter, fromEvent } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-carousel-images-dialog',
  imports: [
    MatIcon,
    MatDialogClose,
    MatStepper,
    MatStep,
    MatButton,
    MatStepperPrevious,
    MatStepperNext,
  ],
  templateUrl: './carousel-images-dialog.html',
  styleUrl: './carousel-images-dialog.scss',
})
export class CarouselImagesDialog implements AfterViewInit {
  private destroyRef = inject(DestroyRef);
  readonly data = inject<{ carouselImages: StoryImage[], selectedImageId: string }>(MAT_DIALOG_DATA);
  @ViewChild('stepper', {read: MatStepper}) stepper!: MatStepper;

  ngAfterViewInit() {
    // Jump to selected image after view init
    const index = this.data.carouselImages.findIndex(
      img => img.id === this.data.selectedImageId,
    );
    if (index >= 0) {
      setTimeout(() => this.stepper.selectedIndex = index);
    }

    // Listen to KeyDown
    this.listenToKeyboard();
  }

  private listenToKeyboard(): void {
    fromEvent<KeyboardEvent>(window, 'keydown').pipe(
      takeUntilDestroyed(this.destroyRef),
      // Only react to ArrowLeft / ArrowRight
      filter(ev => ev.key === 'ArrowLeft' || ev.key === 'ArrowRight'),
      // Ignore when typing in inputs/textarea/contentEditable
      filter(() => {
        const active = document.activeElement as HTMLElement | null;
        if (!active) return false;
        return !(
          active.tagName === 'INPUT' ||
          active.tagName === 'TEXTAREA' ||
          active.isContentEditable
        );
      }),
    ).subscribe((event: KeyboardEvent): void => {
      if (event.key === 'ArrowRight') {
        const last = this.stepper.selectedIndex === this.stepper.steps.length - 1;
        if (!last) this.stepper.next();
      } else if (event.key === 'ArrowLeft') {
        const first = this.stepper.selectedIndex === 0;
        if (!first) this.stepper.previous();
      }

      event.preventDefault();
    });
  }

}
